export default __webpack_public_path__ + "static/media/men.87e7d272.jpeg";